import styled from 'styled-components';

export const Img = styled.img`
  user-select: none;
`;



// WEBPACK FOOTER //
// ./components/atoms/Icon/layout.js